import React from 'react';
import avatar1 from '../components/assets/images/avatar-01.png';

const Game = () => {
    return(
        <main>
            <section>
                <div className="container">
                    A crear el juego
                    <div className="row">
                        <div className='col-xs-4'>
                            <img src={avatar1} className='img-fluid' alt='jesus-1' />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default Game;